import { L, M, XL, XS } from './utils';

import { IconElementProps } from './types';
import styled from 'styled-components';

const calculateSize = (size?: string) => {
	switch (size) {
		case XS:
			return '4px';
		case M:
			return '18px';
		case L:
			return '32px';
		case XL:
			return '40px';
		case undefined:
		default:
			return '25px';
	}
};

export const IconElement = styled.img<IconElementProps>`
	cursor: ${({ cursor }) => cursor};
	width: ${({ size }) => calculateSize(size)};
	height: ${({ size }) => calculateSize(size)};
	filter: ${({ color }) => color};
	fill: ${({ color }) => color};

	&.isOpen {
		rotate: 180deg;
	}
	&.pointer {
		cursor: pointer;
	}
`;
